import { render, staticRenderFns } from "./Attestations.vue?vue&type=template&id=aa7e3480&scoped=true&"
import script from "./Attestations.vue?vue&type=script&lang=js&"
export * from "./Attestations.vue?vue&type=script&lang=js&"
import style0 from "./Attestations.vue?vue&type=style&index=0&id=aa7e3480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7e3480",
  null
  
)

export default component.exports